/**
 * DescriptiveAnswerView — Parsed Feedback view for runs whose prompt declares
 * `outputSchemaType: 'DescriptiveAnswerV1'`. Admin-debug wrapper around the
 * canonical `DescriptiveAnalysis` schema view, plus the admin-only cross-check
 * block (student answer, correct answer, confidence).
 */
import type { Feedback } from '@padcanvas/shared';
import { DescriptiveAnalysis } from '../solution-analysis';
import { AdminCrossCheckFields, type SolutionLearningMoment, type RejectMomentHandler } from './AdminCrossCheckFields';

interface Props {
    feedback: Feedback;
    question?: { correctAnswer?: string };
    learningMoments?: SolutionLearningMoment[];
    onRejectMoment?: RejectMomentHandler;
}

export function DescriptiveAnswerView({ feedback, question, learningMoments, onRejectMoment }: Props) {
    return (
        <div className="feedback-content">
            <DescriptiveAnalysis feedback={feedback} />
            <AdminCrossCheckFields feedback={feedback} question={question} learningMoments={learningMoments} onRejectMoment={onRejectMoment} />
        </div>
    );
}
